import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Products } from '../_models/products';
import { map } from 'rxjs/operators';
import { RootService } from './root.service';
import { String } from 'typescript-string-operations';

@Injectable({
  providedIn: 'root'
})
export class ProductsService  {

  BaseURI : string ;

  constructor(private http:HttpClient ,private rootService : RootService) {
       this.BaseURI =  this.rootService.GetBaseURL();
   }

  getProductList(){
    let url = this.rootService.GetBaseURL();
     return this.http.get(this.BaseURI + '/CSP/get-all-products').pipe(map(res => res));
  }

}
